import { post_middleware_query, post_middleware_query_items } from "services/Middleware"
import useCancelToken from "hooks/UseCancelToken"
import Swal from "sweetalert2"
import useAlertSessionError from "./useAlertSessionError"

interface IMiddlewareQuery {
  skipRecords: number
  maxRecords: number
  sort?: string
  entityType: string
  filter?: any
  project?: Array<string>
}

interface IMiddlewareQueryItems {
  filter: Array<string>
  page?: number
  excludeZeros?: boolean
}

const usePostMiddlewareQuery = () => {
  const { newCancelToken, isCancel } = useCancelToken()
  const { showAlert } = useAlertSessionError()

  const post_middleware_query_action = async (body: IMiddlewareQuery) => {
    try {
      return await post_middleware_query(body, newCancelToken())
    } catch (error: any) {
      if (isCancel(error)) return
      if ([401].includes(error?.response?.status)) return showAlert()
      Swal.fire({
        title: "Error",
        text: error?.response?.data?.message?.error,
        icon: "error",
      })
    }
  }

  const post_middleware_query_items_action = async (body: IMiddlewareQueryItems, channel: string) => {
    try {
      return await post_middleware_query_items(body, channel, newCancelToken())
    } catch (error: any) {
      if (isCancel(error)) return
      if ([401].includes(error?.response?.status)) return showAlert()
      Swal.fire({
        title: "Error",
        text: error?.response?.data?.message?.error,
        icon: "error",
      })
    }
  }

  return {
    post_middleware_query_action,
    post_middleware_query_items_action,
  }
}

export default usePostMiddlewareQuery
